<script lang="ts" setup>
import BasicText from '~/components/form-elements/BasicText.vue'
import PartnerBox from '~/components/partner/PartnerBox.vue'
import PartnerCube from '~/components/partner/PartnerCube.vue'
import PartnerSubtitle from '~/components/partner/PartnerSubtitle.vue'
import Page from '~/enums/page'

const router = useRouter()

const steps = [
  {
    content: 'Заполните заявку для\xA0партнёрства',
  },
  {
    content: 'Заполняете анкету после\xA0получения доступа в\xA0личный кабинет',
  },
  {
    content: 'Заполняете анкету после\xA0получения доступа в\xA0личный кабинет',
  }
]
</script>

<template>
  <PartnerBox class="my-2 lg:!flex lg:!flex-row">
    <PartnerSubtitle
      class="!mb-5 lg:!mb-0 lg:w-[calc(50%-16px)]"
      subtitle="3&nbsp;простых шага, чтобы&nbsp;начать зарабатывать"
    />

    <div class="flex flex-col flex-wrap md:flex-row lg:mr-8 lg:w-[calc(50%-16px)]">
      <PartnerCube
        v-for="(x, i) in steps"
        :key="i"
        class="mb-3 md:mr-3 md:w-[calc(50%-12px)]"
        :index="'Шаг ' + (i + 1)"
      >
        <BasicText :text="x.content" />
      </PartnerCube>

      <SpecialCube
        class="mb-3 md:w-[calc(50%-12px)]"
        title="Стать партнёром iTAB"
        @click.prevent="router.push({ path: Page.PartnerSignup })"
      />
    </div>
  </PartnerBox>
</template>
